module.exports = __webpack_public_path__ + "5c55aaa5431f463b2d663baf6ae933a1.jpg";